import CenteredMessage from "../../../components/CenteredMessage";

const AdminDashboard = () => {
  return <CenteredMessage message="Admin Dashboard" height="90vh" />;
};

export default AdminDashboard;
